import { LocalityCategoryInteractor, LocalityCategoryRequest, LocalityCategoryStructRequest } from "../../Coordinator/LocalityCategory/LocalityCategoryInteractor";

export class LocalityCategoryViewModel {
	private interactor: LocalityCategoryInteractor;

	constructor() {
		this.interactor = new LocalityCategoryInteractor();
	}

	public fetchSave(obj: any): PromiseLike<any> {
		var request = new LocalityCategoryRequest(
			obj["sgepcategorialocalidade"] ? parseInt(obj["sgepcategorialocalidade"]) : 0,
			obj["nome"] ? obj["nome"] : "",
			obj["codigo"] ? obj["codigo"] : "",
		)
		return new Promise((res, rej) => {
			this.interactor.fetchSave(request).then((result) => {
				return res(true)
			}, e => {
				return rej(e)
			});
		})
	}

	public fetchDataOne(obj: any): PromiseLike<any> {
		var request = new LocalityCategoryStructRequest(obj["sgepcategorialocalidade"] ? parseInt(obj["sgepcategorialocalidade"]) : 0)
		return new Promise((res, rej) => {
			this.interactor.fetchDataOne(request).then((result) => {
				return res(result)
			}, e => {
				return rej(e)
			});
		})
	}
}